var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { pdpHeroSectionContent, preferASubscriptionFeaturetteContent, readySetNomFeaturetteContent, rtbWithImagesSectionContent, samplerPackFAQsContent, } from '@marketing/components/sections/content';
import PDPHeroSection from '@marketing/components/sections/heroes/PDP';
import FAQSection from '@marketing/components/sections/non_product/FAQ';
import Featurette from '@marketing/components/sections/non_product/Featurette';
import Newsletter from '@marketing/components/sections/non_product/Newsletter';
import RTBWithImagesSection from '@marketing/components/sections/non_product/RTB/RTBWithImages';
import NutritionToggle from '@marketing/components/sections/product/nutrition/Toggle';
import { MealName } from '@marketing/content';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGoogleTagManagerEvent } from '@trackers';
var MealSamplerProductListing = function () {
    useEffect(function () {
        sendGoogleTagManagerEvent({
            event: 'view-sampler_pack',
        });
    }, []);
    var pdpHeroContent = pdpHeroSectionContent[MealName.SamplerPack];
    return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Fresh dog food Sampler Pack | Nom Nom" }), _jsx("meta", { name: "description", content: "Try Nom Nom with our fresh dog food Sampler Pack. Four meal samples so your pup can pick a favorite." }), _jsx("link", { rel: "canonical", href: "https://nomnomnow.com/meals/sampler-pack" })] }), _jsxs("div", __assign({ className: "header-lining bg-surface-beige" }, { children: [_jsx(PDPHeroSection, { content: pdpHeroContent }), _jsx(NutritionToggle, { recipes: [
                            {
                                name: MealName.Beef,
                                productName: MealName.Beef,
                            },
                            {
                                name: MealName.Turkey,
                                productName: MealName.Turkey,
                            },
                            {
                                name: MealName.Pork,
                                productName: MealName.Pork,
                            },
                            {
                                name: MealName.Chicken,
                                productName: MealName.Chicken,
                            },
                        ] }), _jsx(Featurette, { content: readySetNomFeaturetteContent, flip: true, theme: "dark", buttonTheme: "dark", backgroundColorStyle: "bg-surface-blue-dark" }), _jsx(RTBWithImagesSection, { backgroundColorStyle: "bg-surface-bacon", content: rtbWithImagesSectionContent }), _jsx(FAQSection, { content: samplerPackFAQsContent }), _jsx(Featurette, { content: preferASubscriptionFeaturetteContent, backgroundColorStyle: "bg-action-surface-primary", flip: true }), _jsx(Newsletter, {})] }))] }));
};
export default MealSamplerProductListing;
